
<div class="container">
    <br>
    <app-user-setting *ngFor="let n of tabs; index as i" [index]="i" [inputForm]="n"></app-user-setting>
    <br>
</div>


